import { shortFormatNumber } from '../../../../util'
import { ChangeTypeEnum } from '../../constants'

export function tickFormatter(value?: number | null, type?: ChangeTypeEnum, fractions = 0) {
  const formattedNumber = shortFormatNumber(value, { fractions })
  if (type !== ChangeTypeEnum.Percentage) {
    return formattedNumber
  }
  return `${formattedNumber}%`
}

export function formatQuarter(quarterString: string) {
  // This will be changed when BE changes querter format in DB
  return quarterString
}
